import axios from "axios"
import * as XLSX from 'xlsx';

import AiAgentService from "@/services/cis-aiagent.service";

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

const boldStyle = { font: { name: 'Consolas', bold: true } };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };

export default class ExpXlMarketOverview {
    constructor() {
        XLSX = require("xlsx-js-style");
    }

    newSheet4Data(columns, data) {
        var tmp_sheet = [];

        // Header
        var header_list = ['No.', '키워드'].concat(columns)
        var tmp_header = [];

        for (const col_nm of header_list)
            tmp_header.push({ v: col_nm, t: "s", s: boldStyle });

        tmp_sheet.push(tmp_header);

        // Data
        for (const idx in data) {
            var tmp_row = [];

            tmp_row.push(Number(idx) + 1);
            tmp_row.push(data[idx].brand);

            for (const sub_item of data[idx].data)
                tmp_row.push({ t: "n", v: Number(sub_item).toFixed(1), s: floatNumStyle });

            tmp_sheet.push(tmp_row)
        }

        var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
        // ws['!cols'] = this.autoFit(tmp_sheet)

        return ws;
    }

    async xlExport(cat_id, st_dt, en_dt, dataset, target_dir = "") {
        if (dataset.length == 0) 
            return ""

        const workbook = XLSX.utils.book_new()	// 엑셀 생성

        for (const sheet of dataset) {
            const sheet_nm = sheet.sheet_nm.replace(/[\/]/g, '').trim().substring(0, 31)

            XLSX.utils.book_append_sheet(workbook, 
                                         this.newSheet4Data(sheet.cat, sheet.data), 
                                         sheet_nm)
        }

        // 엑셀 → ArrayBuffer 변환
        const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // Blob으로 변환 후 FormData에 담아 전송
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const file_nm = 'market_overview_' + cat_id + '_' + st_dt + '_' + en_dt + '.xlsx'

        const formData = new FormData();
        formData.append('file', blob, file_nm);
        formData.append('filename', file_nm); // 저장 경로 전달
        formData.append('target_dir', target_dir);

        const response = await AiAgentService.callAiAgent_SaveExcel(formData, source)

        if(response && response.status == 200)
            return response.data.data.path
            // return response.data.path // for local test
        else
            return ""
    }

    async fileExist(cat_id, st_dt, en_dt, target_dir = "") {
        const file_nm = 'market_overview_' + cat_id + '_' + st_dt + '_' + en_dt + '.xlsx'

        const formData = new FormData();
        formData.append('filename', file_nm); // 저장 경로 전달
        formData.append('target_dir', target_dir);

        const response = await AiAgentService.callAiAgent_FileExist(formData, source)

        if(response && response.status == 200)
            return response.data.data.exist
            // return response.data.exist // for local test
        else
            return false
    }
}